<template>
  <div class="glasses-product-detail-article-views gpdp-mobile-order-0">
    <div class="gpdp-grid-row">
      <div v-for="variant in Variants" :id="(variant === '' ? 'main' : variant.toLowerCase()) + '-thumb'" :key="variant">
        <div @click="$emit('viewClicked', variant)" class="article-view-thumb-nav">
          <img class="img-fluid" :src="getImage(variant)"/>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {computed} from 'vue'
import config from "@/config";
import {getImageName} from '@/composable/eonUtils'

export default {
  name: "GlassViewSelect",
  props: {
    Glassitem: Object,
    Color: Object,
    viewVariants: Array
  },
  setup(props) {

    const color = computed(() => {
      return props.Color
    })
    const glass = computed(() => {
      return props.Glassitem
    })
    const Variants = computed(() => {
      return props.viewVariants
    })
    return {
      color,
      getImageName,
      Variants,
      glass
    }
  },
  methods: {

    getImage: function (view = '') {
      return config.glassesBaseUrl + this.getImageName(this.glass, this.color, 'xsmall', view)

    }
  },
};
</script>
